// Legacy overlay close bar (WEB-8004). Shell chrome — composed by
// workspaceStyles.ts in place.
export const legacyOverlayCloseBar = `
/* ===== Legacy overlay close bar ===== */
.ws-overlay-close-bar {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  padding: 6px 32px;
  border-bottom: 1px solid var(--ws-line);
  background: var(--ws-bg);
}
.ws-overlay-close {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  font-family: var(--ws-sans);
  font-size: 12px;
  font-weight: 500;
  color: var(--ws-ink-3);
  background: none;
  border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-sm);
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;
}
.ws-overlay-close:hover {
  color: var(--ws-ink);
  border-color: var(--ws-line-2);
}

.ws-template-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(123, 97, 255, 0.12);
  color: #5b3df0;
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
}
.ws-template-badge--off {
  background: rgba(107, 114, 128, 0.12);
  color: #6b7280;
}
.ws-template-badge__off-suffix {
  opacity: 0.8;
}
.ws-template-badge--compact {
  padding: 0;
  width: 18px;
  height: 18px;
  justify-content: center;
  gap: 0;
}

.ws-hire-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ws-hire-row {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--ws-line);
  border-radius: 10px;
  background: var(--ws-panel);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  overflow: hidden;
}
.ws-hire-row:hover {
  border-color: var(--ws-line-2);
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
}
.ws-hire-row-clickable .ws-hire-row-main {
  cursor: pointer;
}
.ws-hire-row-main {
  display: grid;
  grid-template-columns: 44px 1fr auto;
  gap: 14px;
  align-items: center;
  padding: 14px;
}
.ws-hire-row-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: rgba(123, 97, 255, 0.10);
  color: #5b3df0;
  overflow: hidden;
}
.ws-hire-row-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.ws-hire-row-body {
  min-width: 0;
}
.ws-hire-row-title-line {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.ws-hire-row-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--ws-ink);
}
.ws-hire-row-pill {
  display: inline-flex;
  align-items: center;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  background: var(--ws-soft);
  color: var(--ws-ink-3);
}
.ws-hire-row-pill-new {
  background: rgba(47, 122, 78, 0.12);
  color: var(--ws-ok);
}
.ws-hire-row-role {
  font-size: 12.5px;
  color: var(--ws-ink-3);
  margin-top: 2px;
}
.ws-hire-row-mission {
  font-size: 12.5px;
  color: var(--ws-ink-4);
  margin-top: 6px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: pre-wrap;
}

.ws-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.4);
  display: grid;
  place-items: center;
  z-index: 1000;
}
.ws-modal {
  background: var(--ws-panel);
  border-radius: 12px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.2);
  width: 440px;
  max-width: calc(100vw - 32px);
  overflow: hidden;
}
.ws-modal-head {
  padding: 16px 20px 8px;
}
.ws-modal-head h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--ws-ink);
}
.ws-modal-body {
  padding: 4px 20px 16px;
  font-size: 13px;
  color: var(--ws-ink-3);
  line-height: 1.55;
}
.ws-modal-body p {
  margin: 0;
}
.ws-modal-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px;
  background: var(--ws-soft);
  border-top: 1px solid var(--ws-line);
}
.ws-btn-primary {
  background: var(--ws-ink);
  color: #fff;
  border-color: transparent;
}
.ws-btn-primary:hover {
  background: var(--ws-ink-2);
}
.ws-btn-danger {
  background: #b84a3e;
  color: #fff;
  border-color: transparent;
}
.ws-btn-danger:hover {
  filter: brightness(1.05);
}

/* Playbook editor controls (WEB-6632) */
.ws-input,
.ws-select {
  border: 1px solid var(--ws-line);
  border-radius: 6px;
  background: var(--ws-bg);
  color: var(--ws-ink);
  font: inherit;
}
.ws-input:focus,
.ws-select:focus {
  outline: none;
  border-color: var(--ws-ink-3);
}
.ws-input:disabled,
.ws-select:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.ws-btn-xs {
  padding: 2px 8px;
  font-size: 11px;
  line-height: 1.4;
  display: inline-flex;
  align-items: center;
  gap: 3px;
}
.ws-auto-badge {
  font-size: 11px;
  padding: 1px 6px;
  border-radius: 10px;
  background: var(--ws-soft);
  color: var(--ws-ink-3);
}
/* Wrapper that lets the assigned agent's avatar take the routine row's fixed
   left slot (the one .ws-auto-icon otherwise occupies) and carry a tooltip. */
.ws-auto-avatar {
  display: inline-flex;
  flex-shrink: 0;
}
.ws-spin {
  animation: ws-spin 0.9s linear infinite;
}

.ws-skill-group-head {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--ws-ink-4);
  padding: 14px 4px 8px 4px;
}
.ws-skill-group-head::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--ws-ink-5);
  flex-shrink: 0;
}
.ws-skill-group-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  border-radius: 9px;
  background: rgba(29, 61, 72, 0.08);
  font-size: 10.5px;
  font-weight: 500;
  color: var(--ws-accent);
  text-transform: none;
  letter-spacing: 0;
}

/* Premium card treatment for the Skills tab — warm off-white that lifts off
   the page bg without the visual noise of a coloured top stripe. */
.ws-skills-card {
  background: linear-gradient(180deg, #fbfcfd 0%, #ffffff 80px, #ffffff 100%);
  border: 1px solid var(--ws-line);
  border-radius: 12px;
  padding: 22px 22px 20px;
  /* Top gap now comes from .ws-settings-body so every settings tab matches. */
  margin: 0 0 18px;
  box-shadow: 0 1px 2px rgba(20, 36, 50, 0.03);
}
/* Skill row title + pills: line up vertically, breathe horizontally */
.ws-skills-card .ws-auto-label {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.ws-skills-card .ws-admin-card-head {
  margin-bottom: 4px;
}
.ws-skills-card .ws-admin-card-head h3 {
  font-family: var(--ws-serif);
  font-weight: 600;
  font-size: 19px;
  letter-spacing: -0.01em;
  color: var(--ws-accent);
}
.ws-skills-card .ws-sub {
  font-size: 12.5px;
  color: var(--ws-ink-4);
  display: block;
  margin-top: 4px;
}

/* Active-count chip in the card head — small and quiet */
.ws-skill-active-chip {
  display: inline-flex;
  align-items: center;
  height: 18px;
  padding: 0 8px;
  border-radius: 999px;
  background: rgba(29, 61, 72, 0.08);
  color: var(--ws-accent);
  font-size: 10.5px;
  font-weight: 500;
  letter-spacing: 0;
  font-family: var(--ws-sans);
  text-transform: none;
  line-height: 1;
}

/* Per-scope icon chips — keeps each row visually anchored to its origin */
.ws-auto-icon-skill-user {
  background: rgba(74, 107, 133, 0.10);
  color: var(--ws-a-forecasting);
}
.ws-auto-icon-skill-customer {
  background: rgba(184, 147, 90, 0.14);
  color: var(--ws-a-human);
}
.ws-auto-icon-skill-upsales {
  background: rgba(29, 61, 72, 0.12);
  color: var(--ws-accent);
}

/* Per-scope pill colours — refined and editorial, not Bootstrap-loud.
   Sized down to sit comfortably next to a row title without competing. */
.ws-skills-card .ws-pill {
  font-size: 9.5px;
  padding: 1px 6px;
  height: 16px;
  letter-spacing: 0.04em;
}
.ws-pill-scope-user {
  background: rgba(74, 107, 133, 0.10);
  color: var(--ws-a-forecasting);
  border-color: rgba(74, 107, 133, 0.22);
}
.ws-pill-scope-customer {
  background: rgba(184, 147, 90, 0.14);
  color: var(--ws-a-human);
  border-color: rgba(184, 147, 90, 0.28);
}
.ws-pill-scope-upsales {
  background: var(--ws-accent);
  color: #e8f9f8;
  border-color: var(--ws-accent);
}

/* Skill rows: subtle hover and a faint per-scope tint when expanded */
.ws-skills-card .ws-auto-row {
  background: #ffffff;
  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
}
.ws-skills-card .ws-auto-row:hover {
  background: #fbfcfd;
  border-color: var(--ws-line-2);
}
.ws-skills-card .ws-auto-row-expanded {
  box-shadow: 0 2px 8px rgba(20, 36, 50, 0.04);
}

/* Editable fields inside an expanded skill (edit, create, import): stronger
   border + faint inset so they read clearly against the white card. The
   default ws-agent-edit-input was tuned for the dark Workspace surface and
   disappears on white. */
.ws-skills-card .ws-skill-expanded {
  background: #f7f9fb;
  border-radius: 0 0 var(--ws-r-md) var(--ws-r-md);
}
.ws-skills-card .ws-skill-expanded label > span,
.ws-skills-card .ws-auto-row-expanded label > span {
  font-weight: 500;
  color: var(--ws-ink-3);
}
.ws-skills-card .ws-auto-row-expanded input.ws-agent-edit-input,
.ws-skills-card .ws-auto-row-expanded select.ws-agent-edit-input,
.ws-skills-card .ws-auto-row-expanded textarea {
  background: #ffffff;
  border: 1px solid var(--ws-line-2);
  box-shadow: inset 0 1px 0 rgba(20, 36, 50, 0.02);
  color: var(--ws-ink);
  transition: border-color 0.15s, box-shadow 0.15s;
}
.ws-skills-card .ws-auto-row-expanded input.ws-agent-edit-input:focus,
.ws-skills-card .ws-auto-row-expanded select.ws-agent-edit-input:focus,
.ws-skills-card .ws-auto-row-expanded textarea:focus {
  outline: none;
  border-color: var(--ws-a-forecasting);
  box-shadow: 0 0 0 3px rgba(74, 107, 133, 0.12);
}
.ws-skills-card .ws-auto-row-expanded input.ws-agent-edit-input:disabled,
.ws-skills-card .ws-auto-row-expanded textarea:disabled {
  background: #f1f3f6;
  color: var(--ws-ink-3);
}

.ws-pages-row-delete {
  display: inline-flex;
  align-items: center;
  padding: 6px;
  border: 0;
  border-radius: var(--ws-r-sm);
  background: transparent;
  color: var(--ws-ink-5);
  font: inherit;
  font-size: 12px;
  cursor: pointer;
  transition: color 220ms ease, background-color 220ms ease, padding 220ms ease;
}
.ws-pages-row-delete:hover {
  color: var(--ws-err);
}
.ws-pages-row-delete:disabled {
  cursor: wait;
}
.ws-pages-row-delete-confirm,
.ws-pages-row-delete-confirm:hover {
  color: #ffffff;
  background: var(--ws-err);
  padding: 6px 10px 6px 8px;
}
.ws-pages-row-delete-label {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  max-width: 0;
  margin-left: 0;
  opacity: 0;
  transform: translateX(-4px);
  transition: max-width 260ms ease, margin-left 260ms ease, opacity 200ms ease 60ms, transform 260ms ease;
}
.ws-pages-row-delete-confirm .ws-pages-row-delete-label {
  max-width: 240px;
  margin-left: 6px;
  opacity: 1;
  transform: translateX(0);
}

/* AI provider (BYOK) form inputs */
.ws-prov-input {
  width: 100%;
  box-sizing: border-box;
  padding: 7px 10px;
  border: 1px solid var(--ws-line-2);
  border-radius: var(--ws-r-sm);
  background: #fff;
  font-family: var(--ws-sans);
  font-size: 13px;
  color: var(--ws-ink);
  transition: border-color 0.12s, box-shadow 0.12s;
}
.ws-prov-input::placeholder { color: var(--ws-ink-5); }
.ws-prov-input:focus { outline: none; border-color: var(--ws-accent); box-shadow: 0 0 0 3px var(--pr-accent-soft-2); }
`;
